var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.75 15.9375V16.4375H59.25H61.5C62.6046 16.4375 63.5 17.3329 63.5 18.4375C63.5 19.5421 62.6046 20.4375 61.5 20.4375H59.25H58.75V20.9375V23.1875C58.75 24.2921 57.8546 25.1875 56.75 25.1875C55.6454 25.1875 54.75 24.2921 54.75 23.1875V20.9375V20.4375H54.25H52C50.8954 20.4375 50 19.5421 50 18.4375C50 17.3329 50.8954 16.4375 52 16.4375H54.25H54.75V15.9375V13.6875C54.75 12.5829 55.6454 11.6875 56.75 11.6875C57.8546 11.6875 58.75 12.5829 58.75 13.6875V15.9375Z",
    fill: "#203468",
    stroke: "#EFF9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1204 30.7582L38.391 31.3217L39.2611 31.6259C50.3523 35.5026 58.75 46.149 58.75 59.125C58.75 60.2296 57.8546 61.125 56.75 61.125H2.5C1.39539 61.125 0.5 60.2296 0.5 59.125C0.5 46.1522 8.8914 35.5048 19.9889 31.6259L20.859 31.3217L20.1296 30.7582C16.4407 27.9084 14.0625 23.4454 14.0625 18.4375C14.0625 9.85677 21.0443 2.875 29.625 2.875C38.2057 2.875 45.1875 9.85677 45.1875 18.4375C45.1875 23.4455 42.8093 27.9084 39.1204 30.7582ZM4.62854 56.5746L4.57281 57.125H5.126H54.124H54.6772L54.6215 56.5746C53.3393 43.9134 42.6191 34 29.625 34C16.6309 34 5.91074 43.9134 4.62854 56.5746ZM29.625 6.875C23.249 6.875 18.0625 12.0615 18.0625 18.4375C18.0625 24.8135 23.249 30 29.625 30C36.001 30 41.1875 24.8135 41.1875 18.4375C41.1875 12.0615 36.001 6.875 29.625 6.875Z",
    fill: "#203468",
    stroke: "#EFF9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/Trend.cc74f926bc6eecab947c849dc2399fdd.svg";
export { ForwardRef as ReactComponent };